import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormDivider from '../common/components/FormDivider'
import AutomatedRemindersSection from '../common/components/formInputs/AutomatedRemindersSection'
import PostEventReviewSection from '../common/components/formInputs/PostEventReviewSection'

const ThirdStep = ({ displayStep, formValues, socialLinksOptions, setFieldValue }) => {
  const { t } = useTranslation(['eventManagement'])

  if (!displayStep) {
    return null
  }

  return (
    <React.Fragment>
      <FormDivider />

      <div className="columns">
        <div className="column is-12">
          <p>{t('eventManagement:common.communication')}</p>
        </div>
      </div>
      <AutomatedRemindersSection
        automatedRemindersToggle={formValues.automatedRemindersToggle}
        remindRsvp={formValues.remindRsvp}
        remindRsvpValues={formValues.remindRsvpValues}
        remindAll={formValues.remindAll}
        remindAllValues={formValues.remindAllValues}
        timeStart={formValues.timeStart}
        setFieldValue={setFieldValue}
      />
      <PostEventReviewSection
        askForPostEventReview={formValues.askForPostEventReview}
        positiveReview={formValues.positiveReview}
        socialLinksOptions={socialLinksOptions}
        socialLinkService={formValues.socialLinkService}
        replyTo={formValues.replyTo}
        buildingId={formValues.building?.id}
        setFieldValue={setFieldValue}
      />
    </React.Fragment>
  )
}

ThirdStep.propTypes = {
  displayStep: PropTypes.bool,
  formValues: PropTypes.object.isRequired,
  socialLinksOptions: PropTypes.array,
  setFieldValue: PropTypes.func.isRequired,
}

export default ThirdStep
